import { LMBaseComponent } from './lm-base.component';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMComponentInfoService, LMLoggerService, LMModalOpenService, LMModalWrapperService } from '@services/index';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { Directive } from '@angular/core';
import { LMAppComponentService } from '@utils/lm-app-component.service';

@Directive()
export abstract class LMBaseFormComponent extends LMBaseComponent {

  protected instanceId: string;

  constructor(
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmLoggerService: LMLoggerService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmAppComponentService: LMAppComponentService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService
  ) {
    super(lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
    this.instanceId = this.lmLoggerService.instanceId;
  }
}

export interface LoadResponse<t> {
  data?: t;
}
